import React, { FunctionComponent, useEffect, useRef } from "react"
import { useSelector, useDispatch } from "react-redux"
import { ApplicationState } from "../../core/types"
import { sendInteractionEvent } from "../../data/stores/in-app-comms/in-app-comms-actions"

export const InAppCommsBanner: FunctionComponent = () => {
    const banner = useSelector((s: ApplicationState) => s.inAppComms.banner)
    const dispatch = useDispatch()
    const deliveredIdRef = useRef<string | null>(null)

    useEffect(() => {
        if (banner && banner.inappMessageId !== deliveredIdRef.current) {
            deliveredIdRef.current = banner.inappMessageId
            dispatch(sendInteractionEvent(banner.inappMessageId, "delivered"))
        }
    }, [banner?.inappMessageId])

    if (!banner) return null

    return (
        <div className={`in-app-comms-banner in-app-comms-banner--${banner.severity}`}>
            <span className="in-app-comms-banner__title">{banner.title}</span>
            {banner.body && (
                <span className="in-app-comms-banner__body">{banner.body}</span>
            )}
        </div>
    )
}
